<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>库存</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.source_account_code">
                <el-input
                    v-model="queryParams.source_account_code"
                    placeholder="请输入源账户代码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>

            <div class="main_header_item" v-if="postList.rid">
                <el-input v-model="queryParams.rid" placeholder="请输入库存源RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.source_account_rid">
                <vSearchSelect
                    model_key="source_account_rid"
                    model_name="请输入源账户搜索"
                    request_uri="searchAccounts"
                    default_option_key="source_account_option"
                    :default_option="queryParams['source_account_option']"
                    @onDropChange="onDropChange"
                    ref="source_account_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.source_file">
                <el-input
                    v-model="queryParams.source_file"
                    placeholder="请输入源文件"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>

            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ is_all: true, type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.product_owner_rid">
                <vSearchSelect
                    model_key="product_owner_rid"
                    model_name="请输入产品所有者搜索"
                    request_uri="searchAccounts"
                    default_option_key="product_owner_option"
                    :default_option="queryParams['product_owner_option']"
                    @onDropChange="onDropChange"
                    ref="product_owner_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.supplier_rid">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="principal_rid"
                    model_name="请选择负责人"
                    request_uri="dropdownPerson"
                    :model_value_default="queryParams['principal_rid']"
                    @onDropChange="onDropChange"
                    ref="principal_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.no_supplier">
                <vDropdown
                    model_key="no_supplier"
                    model_name="请选择供方是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_supplier']"
                    @onDropChange="onDropChange"
                    ref="no_supplier_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_product">
                <vDropdown
                    model_key="no_product"
                    model_name="请选择产品是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_product']"
                    @onDropChange="onDropChange"
                    ref="no_product_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_product_owner">
                <vDropdown
                    model_key="no_product_owner"
                    model_name="请选择产品所有者是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_product_owner']"
                    @onDropChange="onDropChange"
                    ref="no_product_owner_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_partner">
                <vDropdown
                    model_key="no_partner"
                    model_name="请选择合作方是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_partner']"
                    @onDropChange="onDropChange"
                    ref="no_partner_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_business">
                <vDropdown
                    model_key="no_business"
                    model_name="请选择一级商业是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_business']"
                    @onDropChange="onDropChange"
                    ref="no_business_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.no_principal">
                <vDropdown
                    model_key="no_principal"
                    model_name="请选择负责人是否为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['no_principal']"
                    @onDropChange="onDropChange"
                    ref="no_principal_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="confidence"
                    model_name="请选择确信度"
                    select_value="value"
                    request_uri="confidenceSimple"
                    :model_value_default="queryParams['confidence']"
                    @onDropChange="onDropChange"
                    ref="confidence_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.dateValue">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus">新增</el-button>
                <el-button size="small" plain @click="addAcount" v-if="postList.updateBtn" :loading="btnLoading">刷新库存</el-button>
                <el-button size="small" plain @click="relationProduct" :loading="btnLoading">关联产品</el-button>
                <el-button size="small" plain @click="relationOwner" :loading="btnLoading">关联产品所有者</el-button>
                <el-button size="small" plain @click="repertoryPrincipalList" :loading="btnLoading">批量编辑</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="commodity_stock" :queryParams="queryParams" :display_insert="false"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_stock"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['rid'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'repertoryListComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_stock'
            },
            btnLoading: false,
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'rid' && row.rid) {
                this.$router.push({
                    path: '/repertoryDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'product' && row.product_rid) {
            } else if (prop == 'account' && row.source_account_rid) {
            } else if (prop == 'supplier' && row.supplier_rid) {
            } else if (prop == 'owner' && row.product_owner_rid) {
            } else if (prop == 'business' && row.business_rid) {
            } else if (prop == 'partner' && row.partner_rid) {
            } else if (prop == 'principal' && row.principal_rid) {
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                code: '',
                name: '',
                status: '',
                parent_rid: '',
                rank: ''
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_stock_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_stock_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕1
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_stock', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_stock;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'stockSourceLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'stockSourceDelete', row.rid);
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'repertoryEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'repertoryEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'repertoryEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        //刷新库存
        addAcount() {
            var params = {};
            let messages = '此操作将刷新库存，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api
                        .stockSourceFlush(params)
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '刷新成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刷新'
                    });
                });
        },
        relationProduct() {
            this.$router.push({
                path: 'stockProductList',
                query: {}
            });
        },
        relationOwner() {
            this.$router.push({
                path: 'stockOwnerList',
                query: {}
            });
        },
        repertoryPrincipalList() {
            this.$router.push({
                path: 'repertoryPrincipalList',
                query: {}
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>